import { Alert, Button, FormControl, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, Radio, TextField, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";
import { useEffect, useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Styles } from '../../../../styles/material-styles';
import SimpleAutoComplete from "src/components/auto-complete/autocomplete.js";
import RefreshIcon from '@mui/icons-material/Refresh';
import { NotificationVariant } from "src/utils/enums/notification-variants.enum";
import * as LLMService from "../../../../services/llm.service.js";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const styles = {
    header: {
      fontWeight: 'bold',
      color: '#777',
      width: '90%',
    },
};

const itemInitialState = {
    name: '',
    apiUrl: '',
    apiKey: '',
    model: null,
    timeout: 0,
    temperature: 0,
    maxTokens: 0,
    maxContextTokens: 0,
    systemPrompt: '',
    llmType: null,
    contextType: 1
};

const verifyConnectionInitialState = {
    isOk: null,
    message: ""
}

const FormEditDataOpenAi = (props) => {
    const { classes, intl, llm, onShowNotification, onLoading } = props;

    const [llmTypes, setLLMTypes] = useState([]);
    const [llmType, setLLMType] = useState(null);

    const [item, setItem] = useState(itemInitialState);
    // Item 09 (16/10/2026): a API devolve só a máscara da chave ("••••1234"); o campo fica vazio = mantém a atual.
    const [apiKeyMasked, setApiKeyMasked] = useState('');
    const [llmModels, setLLMModels] = useState([]);
    const [verifyConnection, setVerifyConnection] = useState(verifyConnectionInitialState);
    const [showApiKey, setShowApiKey] = useState(false);

    const handleClickShowApiKey = () => setShowApiKey((show) => !show);

    const handleMouseDownApiKey = (event) => {
        event.preventDefault();
    };
    
    const handleMouseUpApiKey = (event) => {
        event.preventDefault();
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
        let newValue = value;

        if (name === 'temperature' || name === 'timeout' || name === 'maxTokens' || name === 'maxContextTokens') {
            if (!newValue) {
                newValue = 0;
            } else if (newValue < 0) {
                newValue *= -1;
            }
        }

        setItem(prev => ({
            ...prev,
            [name]: newValue
        }));
    };

    const handleChangeAutoComplete = (name, value) => {
        let data = value ?? null ;

        setItem(prev => ({
            ...prev,
            [name]: data
        }));
    }

    const handleSubmit = async (event) => {
        onLoading(true);
        event.preventDefault();

        try {
            let payload = {
                ...item,
                llmTypeId: llm?.llmtypeid ?? null,
                model: item.model?.id ?? null
            };

            const response = await LLMService.update(payload);

            if (response?.success) {
                onShowNotification(intl.formatMessage({ id: "edit.success" }));
            } else {
                onShowNotification("Não foi possível salvar o registro.", NotificationVariant.ERROR);
            }
        } catch (err) {
            var message = err?.response?.data?.errors[0] ?? "Não foi possível salvar o registro.";
            onShowNotification(message, NotificationVariant.ERROR);
        } finally {
            onLoading(false);
        }
    }

    const handleFetchModels = async (e) => {
        onLoading(true);

        try {
            if (!item?.apiUrl || (!item?.apiKey && !item?.id))  {
                onShowNotification("Os campos Api url e Api key precisam está preenchidos.", NotificationVariant.ERROR)
                return;
            }

            const payload = {
                apiUrl: item.apiUrl,
                llmId: item?.id ?? null,
                apiKey: item.apiKey,
                path: 'models'
            };

            const response = await LLMService.getLLMModels(payload);

            if (response?.success) {
                var output = response?.data ?? [];
                setLLMModels(output);
            } else {
                onShowNotification("Não foi possível obter os modelos.", NotificationVariant.ERROR);
            }
        } catch (err) {
            onShowNotification("Não foi possível obter os modelos.", NotificationVariant.ERROR);
        } finally {
            onLoading(false);
        }
    }

    const handleVerifyConnection = async () => {
        setVerifyConnection(verifyConnectionInitialState);
        onLoading(true);

        try {
            if (!item?.apiUrl || (!item?.apiKey && !item?.id))  {
                onShowNotification("Os campos Api url e Api key precisam está preenchidos.", NotificationVariant.ERROR)
                return;
            }

            const payload = {
                apiUrl: item.apiUrl,
                llmId: item?.id ?? null,
                apiKey: item.apiKey,
                path: 'models'
            };

            const response = await LLMService.verifyLLMConnection(payload);

            if (response?.success) {
                setVerifyConnection({
                    isOk: true,
                    message: ""
                });
            } else {
                setVerifyConnection({
                    isOk: false,
                    message: response?.data?.errors[0] ?? ""
                }); 
            }
        } catch (err) {
            setVerifyConnection({
                isOk: false,
                message: err?.response?.data?.errors[0] ?? ""
            }); 
        } finally {
            onLoading(false);
        }
    }

    const fetchLLM = async (id) => {
        onLoading(true);

        try {
            if (!id)  {
                onShowNotification("LLM ID Não encontrado.", NotificationVariant.ERROR)
                return;
            }

            let currentModel = null;
            const response = await LLMService.getById(id);

            if (response?.success) {
                let data = response?.data;

                if (data?.apiurl) {
                    try {
                        const payloadGetModels = {
                            apiUrl: data?.apiurl,
                            llmId: id,
                            path: 'models'
                        };
            
                        const responseModels = await LLMService.getLLMModels(payloadGetModels);
            
                        if (responseModels?.success) {
                            var output = responseModels?.data ?? [];
                            setLLMModels(output);
                            currentModel = output?.find(item => item.id === data?.model);
                        }
                    } catch (err) {
                        onShowNotification("Não foi possível obter os modelos.", NotificationVariant.ERROR);
                    }
                }

                setApiKeyMasked(data?.apikey ?? '');
                setItem({
                    id,
                    name: data?.name,
                    apiUrl: data?.apiurl,
                    apiKey: '',
                    model: currentModel,
                    timeout: data?.timeout,
                    temperature: data?.temperature,
                    maxTokens: data?.maxtokens,
                    maxContextTokens: data?.maxcontexttokens ?? 0,
                    systemPrompt: data?.systemprompt,
                    llmType: props?.llmType,
                    llmTypeId: data?.llmtypeid,
                    contextType: data?.contexttype ?? 1,
                    opensearchopensearchconnectionon: data?.opensearchopensearchconnectionon ?? true,
                    opensearchconnectionerrormessage: data?.opensearchconnectionerrormessage ?? ''
                });
            } else {
                onShowNotification("Não foi possível obter os dados da llm.", NotificationVariant.ERROR);
            }
        } catch (err) {
            onShowNotification("Não foi possível obter os dados da llm.", NotificationVariant.ERROR);
        } finally {
            onLoading(false);
        }
    }

    const fetchLLMTypes = async () => {
        try {
            const output = await LLMService.getAllLLMTypes();
            const data = output?.data ?? [];
            
            if (data?.length > 0) {
                setLLMTypes(data);

                const llmType = data?.find(item => item?.id === llm?.llmtypeid);
                setItem(prev => ({...prev, llmType}));
                setLLMType(llmType);
            }
        } catch (err) {
            props.onShowNotification("Não foi possível obter os tipos de llm.", NotificationVariant.ERROR)
        }
    } 

    const onInitStateComponent = async () => {
        setVerifyConnection(verifyConnectionInitialState);
        await fetchLLMTypes();
        if (llm) {
            await fetchLLM(llm?.id);
        }
    }

    useEffect(() => {
        onInitStateComponent();
    }, [llm]);

    return (
        <form name='myForm' className={classes.form} onSubmit={handleSubmit}>
            <Grid container spacing={2} gap={1}>
                {llm?.insufficientquota && <Grid item xs={12} sm={12}>
                    <Alert severity="error">A LLM está indisponível no momento devido à falta de créditos.</Alert>
                </Grid>}
                
                <Grid item xs={12} sm={12}>
                    <SimpleAutoComplete
                        name="llmType"
                        label={intl.formatMessage({ id: "field.llm.types" })}
                        options={llmTypes}
                        stateName='llmType'
                        changeSelect={(stateName, value) => {
                            handleChangeAutoComplete(value)
                        }}
                        disabled
                        selected={llmType}
                        htmlOptions={true}
                    />
                </Grid>

                <Grid item xs={12} sm={12}>
                    <TextField 
                        inputProps={{ maxLength: 250 }} 
                        fullWidth 
                        label={intl.formatMessage({id:"name"})} 
                        autoComplete='fname' 
                        variant='outlined' 
                        name='name' 
                        onChange={handleInputChange} 
                        value={item.name} 
                        required 
                    />
                </Grid>  

                <Grid item xs={12} sm={12}>
                    <Typography variant="h5" style={styles.header}>
                        {intl.formatMessage({ id: "title.api.setting" })}
                    </Typography>
                </Grid>   

                {
                    llmType?.description && (
                        <Grid item xs={12} sm={12}>
                            <Alert severity="info">{llmType.description}</Alert>   
                        </Grid>
                    )
                }
                
                <Grid item xs={12} sm={12}>
                    <TextField 
                        inputProps={{ maxLength: 250 }} 
                        fullWidth 
                        label={intl.formatMessage({id:"field.api.url"})} 
                        variant='outlined' 
                        name='apiUrl' 
                        onChange={handleInputChange} 
                        value={item.apiUrl} 
                        helperText={intl.formatMessage({ id: "helper.field.api.url" })}
                        required 
                    />
                </Grid>

                <Grid item xs={12} sm={12}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel htmlFor="api-key-input">
                            {intl.formatMessage({ id: "field.api.key" })}
                        </InputLabel>
                        <OutlinedInput
                            id="api-key-input"
                            name="apiKey"
                            type={showApiKey ? 'text' : 'password'}
                            value={item.apiKey}
                            placeholder={apiKeyMasked}
                            onChange={handleInputChange}
                            inputProps={{ maxLength: 250 }}
                            endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                aria-label={
                                    showApiKey ? 'Esconder chave da API' : 'Mostrar chave da API'
                                }
                                onClick={handleClickShowApiKey}
                                onMouseDown={handleMouseDownApiKey}
                                onMouseUp={handleMouseUpApiKey}
                                edge="end"
                                >
                                {showApiKey ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                            }
                            label={intl.formatMessage({ id: "api.key" })}
                        />
                        <FormHelperText>
                            {apiKeyMasked ? intl.formatMessage({ id: "llm.api.key.keep.current" }, { masked: apiKeyMasked }) : intl.formatMessage({ id: "helper.field.api.key" })}
                        </FormHelperText>
                    </FormControl>
                </Grid>

                <Grid container item spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <SimpleAutoComplete
                            name="model"
                            label={intl.formatMessage({ id: "model" })}
                            options={llmModels}
                            stateName='model'
                            changeSelect={(stateName, value) => {
                                handleChangeAutoComplete(stateName, value)
                            }}
                            selected={item.model}
                            htmlOptions={true}
                            required
                        />
                        <div style={{display: 'flex', alignItems:'center', gap: 2}}>
                            <Button 
                                size="small" 
                                startIcon={<RefreshIcon fontSize="small"/>} 
                                color="secondary"
                                onClick={handleFetchModels}
                            >
                                {intl.formatMessage({ id: "label.llm.load.models" })}
                            </Button>
                        </div>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField 
                            fullWidth 
                            type="number"
                            inputProps={{ min: 0, max: 300 }}  
                            label={intl.formatMessage({id:"field.timeout"})} 
                            variant='outlined' 
                            name='timeout' 
                            onChange={handleInputChange} 
                            value={item.timeout} 
                            helperText={intl.formatMessage({id:"helper.field.timeout"})}
                            required 
                        />
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={12}>
                    <Typography variant="h5" style={styles.header}>
                        {intl.formatMessage({ id: "title.generate.params" })}
                    </Typography>
                </Grid>

                <Grid container item spacing={2}>

                    <Grid item xs={12} sm={6}>
                        <TextField 
                            type="number"
                            inputProps={{ min: 0 }}
                            fullWidth 
                            label={intl.formatMessage({id:"field.temperature"})} 
                            variant='outlined' 
                            name='temperature' 
                            onChange={handleInputChange} 
                            value={item.temperature} 
                            helperText={intl.formatMessage({id:"helper.field.temperature"})}
                            required 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            type="number"
                            inputProps={{ min: 0 }}
                            fullWidth
                            label={intl.formatMessage({id:"field.max.tokens"})}
                            variant='outlined'
                            name='maxTokens'
                            onChange={handleInputChange}
                            value={item.maxTokens}
                            helperText={intl.formatMessage({id:"helper.field.max.tokens"})}
                            required
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            type="number"
                            inputProps={{ min: 0 }}
                            fullWidth
                            label={intl.formatMessage({id:"field.max.context.tokens"})}
                            variant='outlined'
                            name='maxContextTokens'
                            onChange={handleInputChange}
                            value={item.maxContextTokens}
                            helperText={intl.formatMessage({id:"helper.field.max.context.tokens"})}
                        />
                    </Grid>
                </Grid>

                <Grid  item xs={12} sm={12} md={12} lg={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Typography variant="body1" component="span">
                            {intl.formatMessage({id:"context"})}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <Radio
                                checked={item.contextType == 1}
                                onChange={(e) => handleInputChange(e)}
                                value= {1}
                                color="default"
                                name="contextType"
                                inputProps={{ 'aria-label': true }}
                                size="small"
                            />
                            <span style={{fontSize: '15px', marginTop: '10px'}}>{intl.formatMessage({id:"no.context"})}</span>
                        </Grid>

                        {/*
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <Radio
                                checked={item.contextType == 2}
                                onChange={(e) => handleInputChange(e)}
                                value={2}
                                color="default"
                                name="contextType"
                                inputProps={{ 'aria-label': false }}
                                size="small"
                            />
                            <span style={{fontSize: '15px', marginTop: '10px'}}>{intl.formatMessage({id:"automatic"})}</span>
                        </Grid>
                        */}

                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <Radio
                                checked={item.contextType == 3}
                                onChange={(e) => handleInputChange(e)}
                                value={3}
                                color="default"
                                name="contextType"
                                inputProps={{ 'aria-label': false }}
                                size="small"
                            />
                            {/*<span style={{fontSize: '15px', marginTop: '10px'}}>{intl.formatMessage({id:"manually"})}</span>*/}
                            <span style={{fontSize: '15px', marginTop: '10px'}}>Com contexto</span>
                        </Grid>
                    </Grid>
                    <FormHelperText>
                        {intl.formatMessage({ id: "helper.field.llm.context" })}
                    </FormHelperText>
                </Grid>

                <Grid item xs={12} sm={12}>
                    <TextField 
                        multiline
                        rows={5}
                        fullWidth 
                        label={intl.formatMessage({ id: "field.system.propmpt" })} 
                        variant="outlined" 
                        name="systemPrompt" 
                        onChange={handleInputChange} 
                        value={item.systemPrompt} 
                        helperText="Instrução padrão enviada ao modelo para definir seu comportamento"
                        required 
                        InputProps={{
                            sx: {
                                '& textarea': {
                                    resize: 'vertical',
                                    overflow: 'auto',
                                }
                            }
                        }}
                    />
                </Grid>

                {
                    verifyConnection.isOk != null
                    ? (
                        <Grid item xs={12} sm={12}>
                            {
                                verifyConnection.isOk === true 
                                ? <Alert severity="success">{intl.formatMessage({ id: "test.llm.connection.success" })}</Alert>  
                                : <Alert severity="error">{intl.formatMessage({ id: "test.llm.connection.failure" })} ({verifyConnection?.message})</Alert>  
                            }
                        </Grid>
                    )
                    : null
                }
            
                <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: 15, display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}>
                    <Grid container justify="flex-end" style={{ justifyContent: 'flex-end', gap: 8 }}>
                        <Grid item xs={12} sm={4}>
                            <Button 
                                type='button'
                                fullWidth
                                variant='contained'
                                color='inherit'
                                className={classes.submit}
                                onClick={handleVerifyConnection}
                            >
                                {<FormattedMessage id="test.connection" />}
                            </Button>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Button 
                                type='submit'
                                fullWidth
                                variant='contained'
                                color='primary'
                                className={classes.submit}
                            >
                                {<FormattedMessage id="save" />}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    )
}

export default injectIntl(withStyles(Styles)(FormEditDataOpenAi));